import { useEffect,useRef } from 'react'
import { useFrame,useThree } from '@react-three/fiber'
import type { ArenaDef } from './content'
import { SCENARIO_FAMILY_BY_ARENA,WORLD_COMPOSITIONS,WORLD_LIBRARY_URLS } from './generatedWorldExpansion'
import { SUPREME_GAME_ENGINES } from './SupremeGameEngines'

export type MetamotorRuntimeHealth={
  cycle:readonly ['GENESIS','SYNAPSE','PROMETHEUS','RECALCULATE']
  arenaId:string
  family:string
  genesis:{materialized:boolean;pieceCount:number;assetCount:number;encounter:string;waves:number;aerialBoss:string|null}
  synapse:{supremeEngineCount:number;linkedEngineIds:string[];missingLinks:string[]}
  prometheus:{baselineReady:boolean;engineHealthReady:boolean;accepted:boolean;reason:string}
  lastObserved:number
}

export function metamotorHealthForArena(arena:ArenaDef,engineHealthReady=false):MetamotorRuntimeHealth{
 const composition=WORLD_COMPOSITIONS[arena.id]
 const family=SCENARIO_FAMILY_BY_ARENA[arena.id]??arena.id
 const linkedEngineIds=SUPREME_GAME_ENGINES.map(engine=>engine.id)
 const missingLinks:string[]=[]
 if(!composition&&SCENARIO_FAMILY_BY_ARENA[arena.id])missingLinks.push('world-composition')
 if(linkedEngineIds.length!==10)missingLinks.push('supreme-engine-contract')
 const materialized=!composition||composition.pieces.every(piece=>Boolean(WORLD_LIBRARY_URLS[piece.asset]))
 const pieceCount=composition?.pieces.length??0
 const baselineReady=materialized&&missingLinks.length===0
 return{
  cycle:['GENESIS','SYNAPSE','PROMETHEUS','RECALCULATE'],
  arenaId:arena.id,family,
  genesis:{materialized,pieceCount,assetCount:Object.keys(WORLD_LIBRARY_URLS).length,encounter:composition?.encounter.kind??'base-arena',waves:composition?.encounter.waves??0,aerialBoss:composition?.encounter.aerialBoss??null},
  synapse:{supremeEngineCount:linkedEngineIds.length,linkedEngineIds,missingLinks},
  prometheus:{baselineReady,engineHealthReady,accepted:baselineReady&&engineHealthReady,reason:baselineReady?(engineHealthReady?'runtime-and-engine-health-green':'awaiting-engine-health'):'missing-runtime-links'},
  lastObserved:0,
 }
}
export function MetamotorRuntimeBridge({arena}:{arena:ArenaDef}){
 const {scene}=useThree(),timer=useRef(0)
 useEffect(()=>{
  const health=metamotorHealthForArena(arena,Boolean(scene.userData.inyronEngineHealth))
  health.lastObserved=performance.now()
  scene.userData.inyronMetamotorHealth=health
 },[arena,scene])
 useFrame((_,dt)=>{
  timer.current+=Math.max(0,dt)
  if(timer.current<1)return
  timer.current=0
  const health=metamotorHealthForArena(arena,Boolean(scene.userData.inyronEngineHealth))
  health.lastObserved=performance.now()
  scene.userData.inyronMetamotorHealth=health
 })
 return null
}
